module.exports = __webpack_public_path__ + "d3c938692307feb901d1a13fd5f95ad5.pdf";